import { render, staticRenderFns } from "./PlayerIconButtons.vue?vue&type=template&id=6def15b6"
import script from "./PlayerIconButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerIconButtons.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports